import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import { AuthenticationService } from '../../../services/authentication.service';
import {ProductListDetailComponent} from '../product-list-detail/product-list-detail.component';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from "rxjs";
import { ProductDetail } from '../product.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;
  modal = null;
  modalData = null;
  searchProductID: any = '';
  searchProductName: any = '';
  searchProductDept: any = '';
  department_choices: any = [];
  groups: any = [];
  totalItems: number;
  currentPage = 1;
  loading = false;
  list: any = [];
  subs: Subscription;
  departmentChoices = [];

  productDetails: ProductDetail[] = [];

  @ViewChild('detailModal') detailModal: ProductListDetailComponent;
  @ViewChild('deleteConfirmation') deleteConfirmationModal: TemplateRef<any>;

  constructor(private apiService: ApiService,
              private translate: TranslateService,
              private authService: AuthenticationService,
              private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.subs = this.translate.onLangChange.subscribe(() => {
      this.loadDepartment();
    });
    this.loadDepartment();
    this.loadData();
  }

  reload() {
    this.pageChanged();
  }

  pageChanged() {
    this.loadData();
  }

  optionChanged() {
    this.search();
  }

  openModal(data, index) {
    this.detailModal.open(this, data);
  }

  search() {
    this.currentPage = 1;
    this.loadData();
  }

  loadData() {
    this.loading = true;
    const params = {
      page: this.currentPage,
      items_per_page: this.itemsPerPage,
      product_id: this.searchProductID,
      name: this.searchProductName,
      department_name: this.searchProductDept,
    };
    this.apiService.getProducts(params)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (res: any) => {
          this.productDetails = res.results;
          this.totalItems = res.count;
        }
      );
  }

  loadDepartment() {
    this.apiService.getDepartments().subscribe(
      (response: any[]) => {
        this.department_choices = response;
        this.departmentChoices = response.map(
          (item) => {
            return {
              value: item.id,
              label: this.translate.currentLang === 'en'
                ? item.name_en
                : item.name_th
            }
          }
        )
      }
    )
  }

  confirmDelete(index): void {
    this.modalData = this.productDetails[index];
    this.modal = this.modalService.open(this.deleteConfirmationModal, {backdrop: 'static', centered: true});
  }

  confirmedDelete(productId: number): void {
    this.apiService.deleteProduct(productId).subscribe(
      () => {
        this.loadData();
        this.sniff('DELETE_PRODUCT', this.modalData.product_id + ';' + this.modalData.name_en);
        this.revertBack();
      });
  }


  clearSearch() {
    this.searchProductID = '';
    this.searchProductName = '';
    this.searchProductDept = '';
    this.loadData();
  }

  revertBack(): void {
    this.modal.close();
    this.modal = null;
    this.modalData = null;
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'MANAGE_PRODUCT',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  get isAdmin(): boolean {
    return this.authService.isAdmin();
  }
  get isAccountant(): boolean {
    return this.authService.isAccountant();
  }
  get isAccountantAdmin(): boolean {
    return this.authService.isAccountantAdmin();
  }
  get lang(): string {
    return this.translate.currentLang;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list/product-list.component.ts